module.exports = __webpack_public_path__ + "img/sync-white.1ae2d21f.svg";